<template>
  <div class="update-component">
    <h3>Connected as {{userEmail}}</h3>
    <div class="field">
      <label>current password</label>
      <input type="password" name="current-password" placeholder="Enter password" v-model="currentPassword"/>
    </div>
    <div class="field">
      <label>new password</label>
      <input type="password" name="password" placeholder="Enter new password" v-model="password"/>
    </div>
    <div class="field">
      <label>password confirmation</label>
      <input type="password" name="confirm-password" placeholder="Enter new password again" v-model="passwordConfirmation"/>
    </div>
    <div class="actions">
      <button @click.stop.prevent="logout">Logout</button>
      <button @click.stop.prevent="submit" class="main">Update</button>
      <loader v-if="isLoading" label="" class="loader"></loader>
    </div>
  </div>
</template>

<script>
  import Loader from '../Loader.vue'

  function isValid(password) {
    return password && password.length >= 5 && password.length <= 10
  }

  export default {
    name: 'updateProfile',
    components: { Loader },
    data() {
      return {
        currentPassword: '',
        password: '',
        passwordConfirmation: '',
        isLoading: false,
      }
    },
    computed: {
      userEmail() {
        return this.$store.state.session.user && this.$store.state.session.user.email
      },
    },
    methods: {
      logout() {
        this.$store.dispatch('SESSION_DESTROY').then(() => {
          this.$router.push('/')
        })
      },
      submit() {
        if (!isValid(this.currentPassword) || !isValid(this.password) || !isValid(this.passwordConfirmation)) {
          this.$toasted.error('Please fill out all the fields with passwords containing between 5 and 10 characters')
        } else if (this.password !== this.passwordConfirmation) {
          this.$toasted.error('The new password and the password confirmation are not the same')
        } else {
          this.$http.put('user', {
            email: this.$store.state.session.user.email,
            password: this.currentPassword,
            newPassword: this.password,
          }).then(
            () => {
              this.$router.replace(this.$route.query.redirect || '/')
              this.$toasted.info('Password updated')
            },
            () => {
              this.$toasted.error('Password update failed')
            },
          )
        }
      },
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  input {
    box-sizing: border-box;
    margin-bottom: 20px;
  }
  .main {
    float: right;
  }
  .actions {
    position: relative;
    margin-bottom: 20px;
  }
  .loader {
    width: 55px;
    position: absolute;
    top: -26px;
    right: 8px;
  }
  h3 {
    margin-bottom: 40px;
    text-align: center;
    opacity: 0.8;
    font-style: italic;
    font-weight: 100;
  }
  @media (max-width: 500px) {
    .update-component {
      margin: 15px;
      input {
        width: 100%;
      }
    }
  }
  @media (min-width: 501px) {
    .update-component {
      width: 600px;
      margin: 40px auto 80px;
      input {
        width: 600px;
      }
    }
  }
</style>
